import { api } from './client';
import {
  adoptBody,
  normalizeAdoptReport,
  type MirrorAdoptRollbackResult,
  type MirrorAdoptRun,
} from '@/lib/mirrorAdopt';

/**
 * «Принять содержимое потока» (договор `docs/CONTRACTS/mirror-adopt.md`). Пути под `/admin/marathons/:id/…` —
 * шлюз уже ведёт их в courses-service.
 *
 * Предпросмотр — любой админ; применение и откат — только владелец (`subtype_editable`).
 */
export const mirrorAdoptApi = {
  async preview(marathonId: string, subtype: string, sourceId: string) {
    const { data } = await api.post(`/admin/marathons/${marathonId}/mirror-adopt`, adoptBody(subtype, sourceId));
    return normalizeAdoptReport(data);
  },
  async apply(marathonId: string, subtype: string, sourceId: string, expect: string, title: string) {
    const { data } = await api.post(
      `/admin/marathons/${marathonId}/mirror-adopt`,
      adoptBody(subtype, sourceId, { expect, title }),
    );
    return normalizeAdoptReport(data);
  },
  async journal(marathonId: string) {
    const { data } = await api.get(`/admin/marathons/${marathonId}/mirror-adopt`);
    return ((data as { runs?: MirrorAdoptRun[] })?.runs ?? []) as MirrorAdoptRun[];
  },
  async rollback(marathonId: string, runId: string, title: string) {
    const { data } = await api.post(`/admin/marathons/${marathonId}/mirror-adopt/${runId}/rollback`, {
      confirm_title: title,
    });
    return data as MirrorAdoptRollbackResult;
  },
};
